import { Link } from "react-router-dom";

export default function NotFoundBlock() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-28 text-center" data-testid="not-found">
      <p className="font-brush text-7xl text-turq">Lost at sea?</p>
      <h1 className="mt-4 text-3xl font-extrabold text-navy">We couldn't find that page</h1>
      <Link to="/" className="inline-block mt-8 rounded-full bg-sun px-8 py-3.5 font-bold text-navy" data-testid="not-found-home-link">Back to the beach</Link>
    </section>
  );
}
